import React, { useContext } from 'react'
import { MainContext } from '../../context/Main.context';
import { LicenceTypes } from '../../utils/LicenceTypes';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { Tab } from '../Tab/Tab'
import { InputField, InputFieldLabel, InputFieldWrapper } from '../Tab/Tab.styled';

export const InformationsTab = () => {

    const {
        licenceType,
        currentFormTab,
        register,
        errors,
    } = useContext(MainContext);
    
    return (
        <Tab show={currentFormTab === 1}>
            <h2>Informations sur le licencié :</h2>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="firstName">Prénom</InputFieldLabel>
                <InputField 
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="Prénom"
                    {...register("firstName", {
                        required: {
                            value: true,
                            message: "Veuillez entrer le prénom du licencié"
                        }
                    })}
                />
                <ErrorMessage message={errors.firstName && errors.firstName.message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="lastName">Nom</InputFieldLabel>
                <InputField 
                    type="text" 
                    id="lastName" 
                    name="lastName"
                    placeholder="Nom"
                    {...register("lastName", {
                        required: {
                            value: true,
                            message: "Veuillez entrer le nom de famille du licencié"
                        }
                    })}
                />
                <ErrorMessage message={errors.lastName && errors.lastName.message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="birthdate">Date de Naissance</InputFieldLabel>
                <InputField 
                    type="date"
                    id="birthdate"
                    name="birthdate"
                    placeholder="Date de Naissance" 
                    {...register("birthdate", {
                        required: {
                            value: true,
                            message: "Veuillez entrer la date de naissance du licencié"
                        }
                    })}
                />
                <ErrorMessage message={errors.birthdate && errors.birthdate.message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="address">Adresse</InputFieldLabel>
                <InputField 
                    type="text"
                    id="address"
                    name="address"
                    placeholder="Adresse"
                    {...register("address", {
                        required: {
                            value: true,
                            message: "Veuillez entrer l'adresse du licencié"
                        }
                    })}
                />
                <ErrorMessage message={errors.address && errors.address.message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="zipcode">Code Postal</InputFieldLabel>
                <InputField
                    type="number"
                    id="zipcode"
                    name="zipcode"
                    placeholder="Code postal"
                    {...register("zipcode", {
                        required: {
                            value: true,
                            message: "Veuillez entrer le code postal"
                        }
                    })}
                />
                <ErrorMessage message={errors.zipcode && errors.zipcode.message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="city">Ville</InputFieldLabel>
                <InputField
                    type="text"
                    id="city"
                    name="city"
                    placeholder="Ville"
                    {...register("city", {
                        required: {
                            value: true,
                            message: "Veuillez entrer la ville"
                        }
                    })}
                />
                <ErrorMessage message={errors.city && errors.city.message} />
            </InputFieldWrapper>
            {(licenceType === LicenceTypes.ADULT || licenceType === LicenceTypes.DIRECTON) && 
                <InputFieldWrapper>
                    <InputFieldLabel htmlFor="work">Profession</InputFieldLabel>
                    <InputField
                        type="text"
                        id="work"
                        name="work"
                        placeholder="Profession"
                        {...register("work")}
                    />
                    <ErrorMessage message={errors.work && errors.work.message} />
                </InputFieldWrapper>
            }
        </Tab>
    );
}
